import { Component, useState } from "react";
import { LabelContainer } from "../assets/style";
import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import FormLongLabel from "./FormLongLabel";

export default function SearchDropDownList(props: { title?: any, value?: any, handleValueChange: Function, items: Array<string> }) {
    const { title, value, handleValueChange, items } = props

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "400px",
    };
    const inputStyle = {
        margin: "10px",
        marginLeft: "28px",
        borderRadius: "6px",
        height: "32px",
        minWidth: "170px",
        maxWidth: "400px",
    };

    return (
        <Box sx={containerStyle}>
            {title && <LabelContainer style={{ marginLeft: "20px" }}>{title + ":"} </LabelContainer>}
            <FormControl sx={inputStyle}>
                <Select
                    value={value}
                    onChange={(event) => handleValueChange(event)}
                    style={{ marginBottom: "20px", backgroundColor: "white", height: "32px" }}
                >
                    {items?.map((item, index) => (
                        <MenuItem key={index} value={item}>
                            {item}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>

    );
}
